import React, {Component} from 'react';
import {UserContext} from "../../../core/UserContext";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {UrlBuilder} from "../../../core/url/UrlBuilder";
import {Drawer} from "@mui/material";
import GPayButton from "../../../res/img/gpay-button.svg";
import * as Sentry from "@sentry/react";
import Skeleton from '@mui/material/Skeleton';
import {Alert} from '@mui/material';
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BoltIcon from '@mui/icons-material/Bolt';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

class SubscriptionDrawer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
			isProductsLoading: true,
			products: [],
			paymentErrorMessage: null,
			paymentWarningMessage: null,
			paymentSuccessMessage: null,
			checkedProductId: 'ai_access_plan',
		};
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (this.state.isOpen !== Boolean(nextProps.isOpen)) {
			this.setState({
				isOpen: Boolean(nextProps.isOpen),
				paymentErrorMessage: null,
				paymentWarningMessage: null,
				paymentSuccessMessage: null,
			});

			if (nextProps.isOpen) {
				this.refresh();
			}
		}
	}

	refresh = () => {
		this.setState({
			paymentErrorMessage: null,
			paymentWarningMessage: null,
			paymentSuccessMessage: null,
		});
		this.fetchPurchaseProducts();
	}

	attemptPurchaseAcknowledgment = async (productName, purchaseToken) => {
		let isSuccess = await fetch(UrlBuilder.playPayments.acknowledge(productName, purchaseToken), {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
		}).then(response => response.status === 200)
			.catch(res => {return false;})

		if (isSuccess) {
			let user = await fetch(UrlBuilder.user.currentUserApi())
				.then(response => response.status === 200 ? response.json() : null)
				.catch(res => {
					return null;
				});

			this.context.setUser(user);
			this.refresh();
			return true;
		}

		return false;
	}

	fetchPurchaseProducts = async () => {
		if (this.context.user.activePlanIdentifier === 'ai_access_plan') {
			return;
		}

		if ('getDigitalGoodsService' in window) {
			let service;
			try {
				service = await window.getDigitalGoodsService('https://play.google.com/billing');
			} catch (e) {
				Sentry.captureException(e);
				return;
			}

			if (service) {
				this.setState({ isProductsLoading: true });

				let products = [];

				const fetchedProducts = await service.getDetails(['ai_access_plan']).catch(e => {
					Sentry.captureException(e);
					return [];
				});

				fetchedProducts.forEach(product => {
					const localizedPrice = new Intl.NumberFormat(
						navigator.language,
						{style: 'currency', currency: product.price.currency}
					).format(product.price.value);

					products.push({
						id: product.itemId,
						title: product.title,
						price: localizedPrice,
						description: product.description,
					});
				});

				this.setState({
					isProductsLoading: false,
					products: products,
				});
			}
		}
	}

	attemptPayment = async (productName) => {
		const paymentMethodData = [{
			supportedMethods: 'https://play.google.com/billing',
			data: {
				sku: productName,
			}
		}];

		const paymentDetails = {
			total: {
				label: `Total`,
				amount: {currency: `USD`, value: `0`}
			}
		};

		const request = new PaymentRequest(paymentMethodData, paymentDetails);

		let paymentMade = false;

		try {
			Sentry.captureMessage("1 - Payment showing initiated for " + this.context.user.email);

			const paymentResponse = await request.show();

			Sentry.captureMessage("2 - Payment response obtained for " + this.context.user.email);

			const {token: purchaseToken} = paymentResponse.details;

			Sentry.captureMessage("3 - Payment made for " + this.context.user.email + " with token: " + purchaseToken, {
				extra: {
					response: JSON.stringify(paymentResponse),
				}
			});

			paymentMade = true;

			const isAcknowledgmentSuccess = await this.attemptPurchaseAcknowledgment(productName, purchaseToken);

			if (isAcknowledgmentSuccess) {
				Sentry.captureMessage("4 - Payment acknowledged for " + this.context.user.email + " with token: " + purchaseToken);

				const paymentComplete = await paymentResponse.complete('success');
				Sentry.captureMessage("5 - Payment response completed for " + this.context.user.email);

				this.setState({
					paymentSuccessMessage: "Payment successfully made & subscription started. Thank you!",
					paymentWarningMessage: null,
					paymentErrorMessage: null,
				});

				return;
			} else {
				Sentry.captureMessage("4 - Payment acknowledged failed for " + this.context.user.email + " with token: " + purchaseToken);
				const paymentComplete = await paymentResponse.complete('fail');
			}

		} catch(e) {
			Sentry.captureMessage(`${e.name}: ${e.message}`);
			try {
				await request.abort();
			} catch (e) {}
		}

		if (paymentMade) {
			this.setState({
				paymentSuccessMessage: null,
				paymentWarningMessage: "Your payment was made but is still being processed by Google Play. Please re-open the app in a few moments and your Subscription should be active. If you have any questions please contact us at myworkinprogress.app@gmail.com or leave a feedback message.",
				paymentErrorMessage: null,
			});
		} else {
			this.setState({
				paymentSuccessMessage: null,
				paymentWarningMessage: null,
				paymentErrorMessage: "Your payment failed. Please try again. If you have any questions please contact us at myworkinprogress.app@gmail.com or leave a feedback message.",
			});
		}
	}

	renderFeatureRow = (text, included, highlight = false) => (
		<Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, py: 0.5 }}>
			<CheckCircleIcon sx={{
				fontSize: 18, mt: 0.15, flexShrink: 0,
				color: included ? (highlight ? 'secondary.main' : 'success.main') : 'text.disabled',
				opacity: included ? 1 : 0.4,
			}} />
			<Typography variant="body2" sx={{
				color: included ? 'text.primary' : 'text.disabled',
				fontWeight: highlight ? 600 : 400,
				lineHeight: 1.5,
			}}>
				{text}
			</Typography>
		</Box>
	)

	render() {
		const currentPlanId = this.context.user.activePlanIdentifier ?? 'standard';
		const isSubscribed = currentPlanId === 'ai_access_plan';
		const priceText = this.state.products.length > 0 ? this.state.products[0].price : null;

		return (
			<Drawer
				anchor="right"
				open={this.state.isOpen}
				onClose={this.props.closeSelfFunc}
				PaperProps={{
					sx: {
						width: '90vw',
						maxWidth: '90vw',
					},
				}}
				TransitionComponent={Transition}
			>
				<Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
					{/* Header */}
					<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, pt: 2.5, pb: 1 }}>
						<Typography variant="h6" sx={{ fontWeight: 700, fontSize: 20 }}>
							Your Plan
						</Typography>
						<IconButton onClick={this.props.closeSelfFunc} size="small">
							<CloseIcon fontSize="small" />
						</IconButton>
					</Box>

					{/* Content */}
					<Box sx={{ flex: 1, overflowY: 'auto', px: 2.5, pb: 3 }}>
						{/* Intro */}
						<Typography variant="body2" sx={{ color: 'text.secondary', mb: 3, lineHeight: 1.6 }}>
							Everyone gets full access to AI features. Upgrade to Premium for 10x more AI credits and support the app's development.
						</Typography>

						{/* Free Plan */}
						<Box sx={{
							border: '1px solid',
							borderColor: !isSubscribed ? 'secondary.main' : 'divider',
							borderRadius: 2.5,
							p: 2.5,
							mb: 2,
							position: 'relative',
							bgcolor: !isSubscribed
								? (theme) => theme.palette.mode === 'dark' ? 'rgba(245,0,87,0.04)' : 'rgba(245,0,87,0.02)'
								: 'transparent',
						}}>
							{!isSubscribed && (
								<Box sx={{
									position: 'absolute', top: -10, left: 16,
									bgcolor: 'secondary.main', color: 'white',
									px: 1.5, py: 0.25, borderRadius: 1,
								}}>
									<Typography variant="caption" sx={{ fontWeight: 700, fontSize: 10, letterSpacing: 0.5 }}>
										CURRENT PLAN
									</Typography>
								</Box>
							)}

							<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
								<Typography variant="h6" sx={{ fontWeight: 700, fontSize: 17 }}>
									Free
								</Typography>
								<Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600 }}>
									$0 / month
								</Typography>
							</Box>

							<Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
								{this.renderFeatureRow('Unlimited workouts, routines & exercises', true)}
								{this.renderFeatureRow('Personal records, streaks & 71 badges', true)}
								{this.renderFeatureRow('Goals, measurements & statistics', true)}
								{this.renderFeatureRow('AI workout insights & analysis', true)}
								{this.renderFeatureRow('AI chat assistant & weekly digest', true)}
								{this.renderFeatureRow('Standard AI model', true)}
								{this.renderFeatureRow('15 AI credits / month', true)}
							</Box>
						</Box>

						{/* Premium Plan */}
						<Box sx={{
							border: isSubscribed ? '2px solid' : '1px solid',
							borderColor: isSubscribed ? 'secondary.main' : 'divider',
							borderRadius: 2.5,
							overflow: 'hidden',
							position: 'relative',
						}}>
							{/* Gradient banner */}
							<Box sx={{
								background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main}, ${theme.palette.secondary.dark || '#c51162'})`,
								px: 2.5, py: 2,
								display: 'flex', alignItems: 'center', gap: 1.5,
							}}>
								<Box sx={{
									width: 40, height: 40, borderRadius: '50%',
									bgcolor: 'rgba(255,255,255,0.2)',
									display: 'flex', alignItems: 'center', justifyContent: 'center',
								}}>
									<BoltIcon sx={{ color: 'white', fontSize: 24 }} />
								</Box>
								<Box sx={{ flex: 1 }}>
									<Typography variant="h6" sx={{ fontWeight: 700, fontSize: 17, color: 'white' }}>
										Premium
									</Typography>
									{isSubscribed ? (
										<Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}>
											Active
										</Typography>
									) : (
										<Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.85)' }}>
											{priceText ? `${priceText} / month` : <Skeleton animation="wave" width={70} sx={{ bgcolor: 'rgba(255,255,255,0.3)' }} />}
										</Typography>
									)}
								</Box>
							</Box>

							<Box sx={{ p: 2.5 }}>
								{isSubscribed && (
									<Box sx={{
										bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(76,175,80,0.1)' : 'rgba(76,175,80,0.08)',
										borderRadius: 1.5, px: 2, py: 1, mb: 2,
										display: 'flex', alignItems: 'center', gap: 1,
									}}>
										<CheckCircleIcon sx={{ fontSize: 18, color: 'success.main' }} />
										<Typography variant="body2" sx={{ fontWeight: 600, color: 'success.main' }}>
											You're on Premium
										</Typography>
									</Box>
								)}

								<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11, display: 'block', mb: 1 }}>
									Everything in Free, plus
								</Typography>

								<Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
									{this.renderFeatureRow('Smarter AI model for better answers', true, true)}
									{this.renderFeatureRow('150 AI credits / month (10x more)', true, true)}
									{this.renderFeatureRow('Support a solo developer', true)}
								</Box>

								{/* CTA */}
								{!isSubscribed && (
									<Box sx={{ mt: 2.5 }}>
										{('getDigitalGoodsService' in window) ? (
											<>
												<Box sx={{
													bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
													borderRadius: 1.5, px: 2, py: 1.5, mb: 2,
													textAlign: 'center',
												}}>
													<Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.5 }}>
														Cancel anytime through Google Play. No commitments.
													</Typography>
												</Box>

												<Box sx={{ display: 'flex', justifyContent: 'center' }}>
													<img
														src={GPayButton}
														alt="Subscribe with Google Play"
														width={215}
														style={{ cursor: 'pointer' }}
														onClick={() => this.attemptPayment(this.state.checkedProductId)}
													/>
												</Box>
											</>
										) : (
											<Box sx={{
												bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
												borderRadius: 1.5, px: 2, py: 1.5,
												textAlign: 'center',
											}}>
												<Typography variant="caption" sx={{ color: 'text.secondary' }}>
													Subscriptions are available through the Google Play app.
												</Typography>
											</Box>
										)}
									</Box>
								)}
							</Box>
						</Box>

						{/* Alerts */}
						{this.state.paymentErrorMessage && (
							<Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>{this.state.paymentErrorMessage}</Alert>
						)}
						{this.state.paymentWarningMessage && (
							<Alert severity="info" sx={{ mt: 2, borderRadius: 2 }}>{this.state.paymentWarningMessage}</Alert>
						)}
						{this.state.paymentSuccessMessage && (
							<Alert severity="success" sx={{ mt: 2, borderRadius: 2 }}>{this.state.paymentSuccessMessage}</Alert>
						)}

						{/* Footer note */}
						<Typography variant="caption" sx={{ color: 'text.disabled', display: 'block', mt: 2.5, lineHeight: 1.5 }}>
							Payments are handled securely through Google Play. You can cancel anytime from your Google Play subscriptions.
						</Typography>
					</Box>

					{/* Close button */}
					<Box sx={{ px: 2.5, py: 2, borderTop: '1px solid', borderColor: 'divider' }}>
						<Button
							fullWidth
							variant="outlined"
							onClick={this.props.closeSelfFunc}
							sx={{ textTransform: 'none', fontWeight: 500 }}
						>
							Close
						</Button>
					</Box>
				</Box>
			</Drawer>
		);
	}
}

SubscriptionDrawer.contextType = UserContext;

export default SubscriptionDrawer;
